export default __webpack_public_path__ + "static/media/iPhone 8 - 1.03772110.png";